import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="block text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-12 hover:text-[#f3e5ab]"
          data-testid="forgot-back-home"
        >
          ← Lumière Club
        </Link>

        {sent ? (
          <div className="space-y-6" data-testid="forgot-sent">
            <p className="text-xs uppercase tracking-[0.25em] text-[#d4af37]">Concierge notified</p>
            <h1 className="font-serif text-4xl">Request received.</h1>
            <p className="text-sm text-white/70 leading-relaxed">
              If <span className="text-white/90">{email}</span> belongs to a Lumière member,
              a Concierge will reach out shortly via WhatsApp with a temporary password.
              You will be asked to set a new password the first time you sign in.
            </p>
            <Link
              to="/login"
              className="inline-block bg-[#d4af37] text-black px-6 py-3 text-xs uppercase tracking-[0.2em]"
              data-testid="forgot-back-login"
            >
              Back to sign in →
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-8">
            <div>
              <p className="text-xs uppercase tracking-[0.25em] text-[#d4af37]">Account recovery</p>
              <h1 className="font-serif text-4xl mt-4">Forgot password</h1>
              <p className="text-sm text-white/60 mt-3 leading-relaxed">
                Enter your registered email. A Concierge will verify your identity
                and issue a one-time temporary password via WhatsApp.
              </p>
            </div>

            <div>
              <label className="text-xs uppercase tracking-widest text-white/40">Email</label>
              <input
                type="email"
                className="editorial-input mt-2"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
                autoComplete="email"
                data-testid="forgot-email"
              />
            </div>

            {err && (
              <p className="text-sm text-red-400" data-testid="forgot-error">{err}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#d4af37] text-black py-4 uppercase tracking-[0.2em] text-sm font-medium hover:bg-[#f3e5ab] transition disabled:opacity-50"
              data-testid="forgot-submit"
            >
              {loading ? "Sending…" : "Notify Concierge"}
            </button>

            <p className="text-center text-xs text-white/40">
              Remembered it?{" "}
              <Link to="/login" className="text-[#d4af37] hover:text-[#f3e5ab]">
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
